// extracted by mini-css-extract-plugin
export default {"mainContainer":"Main_mainContainer__putGz","particles":"Main_particles__dFcbi","photo":"Main_photo__Ke2yp","about":"Main_about__BYwBJ"};